import React from 'react';

import { Typography, Link } from '@vtblife/uikit';

import type { QuizSidebar } from '@search/graphql-typings';
import classname from '@search/classname/src';

import './styles.css';

const cn = classname.bind(null, 'QuizBuilderSidebar');

const QuizBuilderSidebar = ({ sidebarData, goToLastStep }: {
    sidebarData: QuizSidebar;
    goToLastStep: () => void;
}) => {
    return (
        <div className={cn()}>
            <div
                className={cn('image')}
                style={{ backgroundImage: `url(${sidebarData.imageSrc})`, }}
            />
            <Typography
                className={cn('title')}
                variant='primary-alone'
                bold
            >
                {sidebarData.title}
            </Typography>
            <Typography
                className={cn('subtitle')}
                variant='secondary-alone'
            >
                {sidebarData.subtitle}
            </Typography>
            <div className={cn('link')}>
                <Link
                    {...(sidebarData.buttonLink ? {
                        href: sidebarData.buttonLink,
                        target: 'blank'
                    } : {
                        onClick: goToLastStep
                    })}
                >
                    <Typography
                        variant={'primary-alone'}
                        bold
                    >
                        {sidebarData.buttonText}
                    </Typography>
                </Link>
            </div>
        </div>
    );
};

export default QuizBuilderSidebar;
